var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Datetime } from '../..';
import UserName from '../user-name';
import { Styled } from './style';
var UpdatedBy = /** @class */ (function (_super) {
    __extends(UpdatedBy, _super);
    function UpdatedBy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UpdatedBy.prototype.render = function () {
        var user;
        var date;
        if (this.props.value.updatedAt && this.props.value.userByUpdatedBy) {
            user = this.props.value.userByUpdatedBy;
            date = this.props.value.updatedAt;
        }
        else {
            user = this.props.value.userByCreatedBy;
            date = this.props.value.createdAt;
        }
        return (React.createElement(Styled, { className: "updated-by" },
            React.createElement(FormattedMessage, { id: "ui_component.last_updated_by", defaultMessage: "Last updated by {username}", values: {
                    username: (React.createElement("span", { className: "username" },
                        React.createElement(UserName, { givenName: user.givenName, familyName: user.familyName }))),
                } }),
            ", ",
            React.createElement(Datetime, { value: date })));
    };
    return UpdatedBy;
}(React.Component));
export default UpdatedBy;
//# sourceMappingURL=index.js.map